// @ts-nocheck TODO: type issues need to be fixed in this file
import { convertToRaw } from 'draft-js';

const getLiteralTextFromEditor = (editorState) => {
  const { blocks } = convertToRaw(editorState.getCurrentContent());

  const mappedBlocks = blocks.map(
    (block) => (!block.text.trim() && '\n') || block.text,
  );

  let newText = '';
  for (let i = 0; i < mappedBlocks.length; i++) {
    const block = mappedBlocks[i];

    // handle last block
    if (i === mappedBlocks.length - 1) {
      newText += block;
    } else {
      // otherwise we join with \n, except if the block is already a \n
      if (block === '\n') newText += block;
      else newText += `${block}\n`;
    }
  }
  return newText;
};

const getTextFromEditorWithoutMentionsandTags = (
  editorState,
  mentionsToReplace = [] as Mention[],
  tagsToReplace = [] as Mention[],
) => {
  let newText = getLiteralTextFromEditor(editorState);
  mentionsToReplace.forEach((mention) => {
    newText = newText.replace(new RegExp(mention.name, 'g'), '');
  });
  tagsToReplace.forEach((tag) => {
    newText = newText.replace(new RegExp(tag.name, 'g'), '');
  });
  return newText;
};

const getTextFromEditor = (
  editorState,
  mentionsToReplace = [] as Mention[],
  tagsToReplace = [] as Mention[],
) => {
  const replacedMentions = [];
  const replacedTags = [];
  let newText = getLiteralTextFromEditor(editorState);
  mentionsToReplace.forEach((mention) => {
    const originalText = newText;
    newText = newText.replace(
      new RegExp(mention.name, 'g'),
      `@__${mention.id}__@`,
    );
    if (originalText !== newText) {
      replacedMentions.push(mention);
    }
  });
  tagsToReplace.forEach((tag) => {
    const originalText = newText;
    newText = newText.replace(new RegExp(tag.name, 'g'), `@__tag:${tag.id}__@`);
    if (originalText !== newText) {
      replacedTags.push(tag);
    }
  });
  return { text: newText, replacedTags, replacedMentions };
};

const getTrimmedMessage = (message) => {
  return message.trim(' ↵ ');
};

const getMentionsToReplace = (selectedMentions, employees) => {
  return selectedMentions.map((id) => {
    const employee = employees.find((emp) => emp.id === id);
    return {
      id,
      name: employee.name || '',
    };
  });
};

const getMentionsFromEditorSate = (editorState, mentions) => {
  const userIdsMentioned = [];
  const message = getLiteralTextFromEditor(editorState);
  mentions.forEach((mention) => {
    if ((message.match(new RegExp(mention.name, 'g')) || []).length > 0) {
      userIdsMentioned.push(mention.id);
    }
  });
  return userIdsMentioned;
};

// https://stackoverflow.com/questions/47420136/how-to-check-empty-spaces-in-draft-js-editor
const getIsEditorHavingText = (editorState) => {
  const content = editorState.getCurrentContent();
  const isEditorEmpty = !content.hasText();
  const currentPlainText = content.getPlainText();
  const lengthOfEditorContent = currentPlainText.length;
  const lengthOfTrimmedContent = currentPlainText.trim().length;
  const isContainOnlySpaces = !isEditorEmpty && !lengthOfTrimmedContent;
  return lengthOfEditorContent !== 0 && !isContainOnlySpaces;
};

export {
  getTextFromEditor,
  getMentionsToReplace,
  getLiteralTextFromEditor,
  getMentionsFromEditorSate,
  getIsEditorHavingText,
  getTrimmedMessage,
  getTextFromEditorWithoutMentionsandTags,
};
